<!--
<div style="text-align: center;">
    <img src="https://lutzangeles.blob.core.windows.net/app/LutzAngelesTimez_PrintingPress.png" style="width:65%;max-width:396px;border-radius:50%;" />
</div>
-->
<div *ngFor="let item of items" class="article-badge">
    <mat-form-field appearance="outline" style="width: 100%;">
        <input matInput value="xxx" style="display: none;" />
        <mat-label>{{ item.PublishedOnUTC | localDateTime }} by {{ item.PublicationPersonScreenName }}</mat-label>
        <div style="display: flex; flex-direction: column;">
            <div style="display: flex; flex-direction: row;">
                <div style="padding: 8px;margin-right: 8px;">
                    <app-image srcPath="{{ item.AvatarBlobPath }}" isApiImage="false" className="app-image-small"></app-image>
                </div>
                <div style="display: flex; flex-direction: column;padding: 8px;margin-top:8px;">
                    <mat-card-title style="display:inline-flex">{{ item.Name }}</mat-card-title>
                    <div class="text-flash-medium-wrapped" style="color: grey;">
                        {{ item.Description }}
                    </div>
                </div>
            </div>
            <div *ngIf="item.HtmlContentId" style="display:flex; flex-direction: row; margin-top:24px; justify-content: left;">
                <button mat-button (click)="viewArticle(item)">
                    <mat-icon class="material-symbols-outlined">
                        read_more
                    </mat-icon>
                    READ ARTICLE
                </button>
            </div>
        </div>
    </mat-form-field>
</div>
